export const CHILD_END_AGE = 26;
